const saveProductReducer = (state = {}, action) => {
    switch (action.type) {
        case 'SAVE_PRODUCT_FULFILLED': {
            return {
                ...state,
                [action.key]: action.payload
            };
        }
        default: {
            return state;
        }
    }
};

export default saveProductReducer;


// WEBPACK FOOTER //
// ./src/reducers/saveProduct.js